'use strict';

(() => {
	try {
		// Never run inside the Shopify Theme Editor / preview contexts.
		// A hard navigation here would break the editor's iframe handshake
		// and cause the "Anpassen" view to hang indefinitely.
		if (window.Shopify && window.Shopify.designMode) return;
		if (window.location.hostname.indexOf('shopifypreview.com') !== -1) return;
		if (window.location.hostname.indexOf('myshopify.com') !== -1) return;
		if (window.self !== window.top) return;

		const params = new URLSearchParams(window.location.search);

		// Editor / preview URLs always carry these params; treat as opt-out.
		if (
			params.has('preview_theme_id') ||
			params.get('_fd') === '0' ||
			params.get('pb') === '0'
		) {
			return;
		}

		if (params.get('geo') === 'false') {
			sessionStorage.setItem('ik_geo_optout', '1');
			return;
		}
		if (sessionStorage.getItem('ik_geo_optout') === '1') {
			return;
		}

		const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

		fetch(root + 'browsing_context_suggestions.json?country[enabled]=true')
			.then((response) => response.json())
			.then((data) => {
				const country = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;

				if (!country || country === 'CH' || country === 'LI') return;

				// Already on the international shop — bailing prevents a same-URL
				// reload loop if this script is ever loaded there.
				const host = window.location.hostname.toLowerCase();
				if (host === 'inakess.com' || host === 'www.inakess.com') return;

				// Preserve path/query/hash and append ?geo=false, matching the
				// manual switcher in bs-currency-switcher.js / settings_data.json
				// so the destination shop's geo script won't bounce us back.
				const target = new URL(window.location.href);
				target.protocol = 'https:';
				target.hostname = 'www.inakess.com';
				target.port = '';
				target.searchParams.set('geo', 'false');
				window.location.replace(target.href);
			})
			.catch(() => {});
	} catch (e) {}
})();
